import { SAVE_CHAT_COUNT } from '../actions/actionTypes';

const initialState = {};

const liveAgentChatCount = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    if (action.type === SAVE_CHAT_COUNT) {
      return {
        ...state,
        ...action.payload,
      };
    } else {
      return state;
    }
  }
};

export default liveAgentChatCount;
